//SPA stands for single page application
import React from "react";
import Header from "../Header/Header";
import "../../assets/styles/Spa.css";
import NewestSingle from "../NewestSingle/NewestSingle.js";
import Music from "../Music/Music.js";
import UpcomingShows from "../UpcomingShows/UpcomingShows.js";
import Footer from "../Footer/Footer.js";
import Gallery from "../Gallery/Gallery.js";
import {Link} from 'react-scroll'


export default function Spa() {
    return (<>
    <Header></Header>
    <div className="spa-main-content-wrapper">
        <div className="spa-main-content">
            <div className="spa-clickable-content">
                <Link  to="newest_single" spy={true} smooth={true}>
                    <button>EXPLORE</button>
                </Link>
            </div>
        </div>
        <div className="spa-main-content-overlay">

        </div>
        <NewestSingle></NewestSingle>
        <Music></Music>
        <UpcomingShows></UpcomingShows>
        <Gallery></Gallery>
        <Footer></Footer>
    </div>
    
    </>)
}